import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import DefaultLayout from '../Layouts/DefaultLayout';

import ContentSlides from '../Components/ContentSlides';
import ProductTitle from '../Components/ProductTitle';

function App() {
    const [product, setProduct] = useState({});
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { tipo, slug, grupo } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchProduct = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/painel/produtos/${tipo}/${slug}/materiais?grupo=${grupo}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/painel/', {
                            state: {
                                message: { type: 'error', text: 'Produto não encontrado!' },
                            },
                        });
                        redirected = true;
                        return;
                    }
                    throw new Error('Erro ao buscar o produto.');
                }

                const data = await response.json();
                setProduct(data.produto);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        fetchProduct();
    }, []);

    useEffect(() => {
        if (product.grupos && product.grupos.length === 0) {
            navigate(`/painel/produtos/${tipo}/${slug}`, {
                state: {
                    message: { type: 'error', text: 'Grupo não encontrado!' },
                },
            });
        }
    }, [product, loading]);

    return (
        <DefaultLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <ProductTitle
                            productName={product.grupos && product.grupos.length > 0 ? product.grupos[0].nome : product.nome}
                            loading={loading}
                            breadcrumb={[
                                { label: 'Produtos', link: `/painel/produtos/${product.tipo_slug}/` },
                                { label: product.nome, link: `/painel/produtos/${product.tipo_slug}/${product.slug}/` },
                                { label: 'Materiais' },
                            ]}
                            back={`/painel/produtos/${product.tipo_slug}/${product.slug}`}
                        />

                        <ContentSlides
                            content={product.grupos && product.grupos.length > 0 && product.grupos[0].materiais}
                            isCarousel={false}
                            url={`/painel/produtos/${product.tipo_slug}/${product.slug}/materiais/${product.grupos && product.grupos.length > 0 ? product.grupos[0].slug : ''}/`}
                            loading={loading}
                        />
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
